const theme = {
    colors: {
        primary: '#F18C32',
        secondary: '#333333',
    }
}

export default theme